import styled from "styled-components";
import { MoreDetailsTextDefaultBox } from "./more-details-text.default.box";

export const MoreDetailsTextMrgreenBox = styled(MoreDetailsTextDefaultBox)`
    background-color: ${props => props.theme.colors.brandPrimaryDark};
    color: ${props => props.theme.colors.textContrast};
`